import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const CrudTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const numSelected = props.selectedRows.length;

  function handleDeleteRows() {
    props.onDelete(props.selectedRows);
  }

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selecionados
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" component="div">
          {props.title}
        </Typography>
      )}

      {numSelected > 0 && (
        <Tooltip title="Excluir">
          <IconButton onClick={handleDeleteRows} aria-label="excluir">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

CrudTableToolbar.propTypes = {
  title: PropTypes.string.isRequired,
  selectedRows: PropTypes.array.isRequired,
  onDelete: PropTypes.func,
};

CrudTableToolbar.defaultProps = {
  title: "",
  selectedRows: [],
  onDelete: () => {},
};

export default CrudTableToolbar;
